import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    tarjetaResumenId: 0,
    banco: '',
    tarjetaMarca: '',
    numeroCuenta: '',
    fechaCierre: '1900-01-01',
    fechaVencimiento: '1900-01-01',
    totalCierrePesos: 0,
    totalCierreDolares: 0,
    totalPagosPesos: 0,
    totalPagosDolares: 0,

    totalAPagar: 0,
    monedaId: 0,
    moneda: null,
    cotizacion: 1,
    
    /* Opciones de Pago: 1. Pesos | 2. Dolares | 3. Todo el resumen en pesos */
    opcionPagoId: 0,
    opcionPago: {
        id: 0,
        nombre: null
    },
    opcionPagoNombre: null,

    /* Documentos */
    pesos: 0,
    importeDebitosPesos: 0,
    importeDebitosDolares: 0,
    debitos: [],
    observaciones: '',

    /* Caja */
    cajaRegistroId: 0,
    cajaRegistro: null,
    cajaRegistroNombre: null,

    tarjetaResumenPagoDatos: [],
    tarjetaResumenPagoDocumentos: [],
    tarjetaResumenPagoDebitos: [],
};

const mutations = {
    updateField,

    'INICIALIZAR' (state, tarjetaResumenId) {
        state.tarjetaResumenId = tarjetaResumenId;
        state.banco = '';
        state.tarjetaMarca = '';
        state.numeroCuenta = '';
        state.fechaCierre = '1900-01-01';
        state.fechaVencimiento = '1900-01-01';
        state.totalCierrePesos = 0;
        state.totalPagosPesos = 0;
        state.totalCierreDolares = 0;
        state.totalPagosDolares = 0;
        state.totalAPagar = 0;
        state.monedaId = 0;
        state.moneda = null;
        state.cotizacion = 1;
        state.opcionPagoId = 0;
        state.opcionPago = {
            id: 0,
            nombre: null
        };
        state.opcionPagoNombre = null;

        inicializarDocumentos (state);
        state.observaciones = '';

        state.cajaRegistroId = 0;
        state.cajaRegistro = null;
        state.cajaRegistroNombre = null;
    },
    'SET_TARJETA_RESUMEN' (state, tarjetaResumen) {
        state.banco = tarjetaResumen.banco;
        state.tarjetaMarca = tarjetaResumen.tarjetaMarca;
        state.numeroCuenta = tarjetaResumen.numeroCuenta;
        state.fechaCierre = moment(tarjetaResumen.fechaCierre).format('YYYY-MM-DD');
        state.fechaVencimiento = moment(tarjetaResumen.fechaVencimiento).format('YYYY-MM-DD');
        state.totalCierrePesos = parseFloat(tarjetaResumen.importeConsumosPesos) + parseFloat(tarjetaResumen.importeGastosPesos);
        state.totalPagosPesos = parseFloat(tarjetaResumen.importePagadoPesos);
        state.totalCierreDolares = parseFloat(tarjetaResumen.importeConsumosDolares) + parseFloat(tarjetaResumen.importeGastosDolares);
        state.totalPagosDolares = parseFloat(tarjetaResumen.importePagadoDolares);
    },
    'SET_OPCION_PAGO' (state, opcionPago) {
        state.opcionPago = opcionPago;

        if (opcionPago) {
            state.opcionPagoId = opcionPago.id? opcionPago.id : 0;
            state.opcionPagoNombre = opcionPago.nombre? opcionPago.nombre.trim() : null;
            // state.opcionPagoNombre = opcionPago.nombre? opcionPago.nombre.toUpperCase().trim() : null;
        } else {
            state.opcionPagoId = 0;
            state.opcionPagoNombre = null;
        }

        switch (state.opcionPagoId) {
            case 1:
                state.totalAPagar = parseFloat(state.totalCierrePesos) - parseFloat(state.totalPagosPesos);
                state.monedaId = 101; // Pesos
                state.moneda = '$'
                // state.cotizacion = 1;
                break;
            case 2:
                state.totalAPagar = parseFloat(state.totalCierreDolares) - parseFloat(state.totalPagosDolares);
                state.monedaId = 102; // Dolares
                state.moneda = 'U$S'
                // state.cotizacion = 1;
                break;
            case 3:
                state.totalAPagar = parseFloat(state.totalCierrePesos) - parseFloat(state.totalPagosPesos)
                    + (parseFloat(state.totalCierreDolares) - parseFloat(state.totalPagosDolares)) * parseFloat(state.cotizacion);
                state.monedaId = 101; // Pesos
                state.moneda = '$';
                // state.cotizacion = 1;
                break;
            default:
                state.totalAPagar = 0;
                state.monedaId = 0;
                state.moneda = null;
                // state.cotizacion = 1;
                break;
        }
    },
    'INICIALIZAR_DOCUMENTOS'(state) {
        inicializarDocumentos (state);
    },
    'SET_CAJA_REGISTRO' (state, cajaRegistro) {
        state.cajaRegistro = cajaRegistro;
        if (cajaRegistro) {
            state.cajaRegistroId = cajaRegistro.id? cajaRegistro.id : 0;
            state.cajaRegistroNombre = cajaRegistro.nombre? cajaRegistro.nombre.toUpperCase().trim() : null;
        } else {
            state.cajaRegistroId = 0;
            state.cajaRegistroNombre = null;
        }
    },

    'SET_DEBITO' (state, debito) {
        state.debitos.push(debito);

        if (state.debitos.lenght != 0) {
            state.importeDebitosPesos = state.debitos
                .filter(t => t.monedaId == 101)
                .reduce((a, b) => a + b.importe, 0);

            state.importeDebitosDolares = state.debitos
                .filter(t => t.monedaId == 102)
                .reduce((a, b) => a + b.importe, 0);
        } else {
            state.importeDebitosPesos = 0;
            state.importeDebitosDolares = 0;
        }
    },
    'DELETE_DEBITO' (state, debito) {
        let itemKey = state.debitos
            .findIndex(t => t == debito);

        if (itemKey != -1) {
            state.debitos.splice(itemKey, 1);
        }

        if (state.debitos.lenght != 0) {
            state.importeDebitosPesos = state.debitos
                .filter(t => t.monedaId == 101)
                .reduce((a, b) => a + b.importe, 0);

            state.importeDebitosDolares = state.debitos
                .filter(t => t.monedaId == 102)
                .reduce((a, b) => a + b.importe, 0);
        } else {
            state.importeDebitosPesos = 0;
            state.importeDebitosDolares = 0;
        }
    },

    'INICIALIZAR_DATOS' (state) {
        state.tarjetaResumenPagoDatos = [];
        state.tarjetaResumenPagoDocumentos = [];
        state.tarjetaResumenPagoDebitos = [];
    },
    'SET_DATOS' (state, params) {
        state.tarjetaResumenPagoDatos = params.tarjetaResumenPagoDatos;
        state.tarjetaResumenPagoDocumentos = params.tarjetaResumenPagoDocumentos;
        state.tarjetaResumenPagoDebitos = params.tarjetaResumenPagoDebitos;
    },
};

function inicializarDocumentos (state) {
    state.pesos = 0;
    state.importeDebitosPesos = 0;
    state.importeDebitosDolares = 0;
    
    state.debitos = [];
}

function getTotalDocumentos (state) {
    if (state.monedaId == 101) {
        return parseFloat(state.pesos) 
            + parseFloat(state.importeDebitosPesos)
            + parseFloat(state.importeDebitosDolares) * parseFloat(state.cotizacion);
    }
    if (state.monedaId == 102) {
        return (parseFloat(state.pesos) / parseFloat(state.cotizacion)) 
            + parseFloat(state.importeDebitosDolares)
            + parseFloat(state.importeDebitosPesos) / parseFloat(state.cotizacion);
    }
    return parseFloat(state.pesos) 
        + parseFloat(state.importeDebitosPesos)
        + parseFloat(state.importeDebitosDolares);
}

function getSaldo (state) {
    return parseFloat(state.totalAPagar) - getTotalDocumentos(state);
}

const getters = {
    getField,
};

const actions = {
    inicializar ( { commit }, tarjetaResumenId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR', tarjetaResumenId);

            apiAxios.get(`tarjetasresumenes/${tarjetaResumenId}/vencimiento`)
                .then(res => {
                    commit('SET_TARJETA_RESUMEN', res.data);
                    /* Recuperamos la caja central */
                    return apiAxios.get('cajas/central');
                })
                .then((res) => {
                    commit("SET_CAJA_REGISTRO", res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
    save ( { state } ) {
        return new Promise((resolve, reject) => {
            let save = true;
            let errorMessage = '';

            let totalDocumentos = getTotalDocumentos(state);

            if (totalDocumentos == 0) {
                save = false;
                errorMessage = "El total de documentos incluidos en el pago no puede ser igual a cero."
            }

            if (save) {
                let tarjetaResumenPago= {
                    tarjetaResumenId: parseInt(state.tarjetaResumenId),
                    monedaId: parseInt(state.monedaId),
                    cotizacion: parseFloat(state.cotizacion),
                    observaciones: state.observaciones.trim()
                };
                
                let tarjetaResumenOrdenPago = {
                    tarjetaResumenPago: tarjetaResumenPago,
                    pesos: parseFloat(state.pesos),
                    debitos: state.debitos.map(item => ({
                        fechaCreditoDebito: moment(item.fechaCreditoDebito).format('YYYY-MM-DD'),
                        bancoCuentaId: item.bancoCuentaId,
                        monedaId: item.monedaId,
                        importe: parseFloat(item.importe),
                    })),
                    cajaRegistroId: state.cajaRegistroId
                };

                apiAxios.post('tarjetasresumenes/pagos', tarjetaResumenOrdenPago)
                    .then(() => resolve())
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                reject(errorMessage);
            }
        })
    },
    setOpcionPago ( { commit }, opcionPago ) {
        return new Promise((resolve, reject) => {
            commit('SET_OPCION_PAGO', opcionPago);
            resolve();
        });
    },
    setCajaRegistro ( { commit }, cajaRegistro ) {
        commit('SET_CAJA_REGISTRO', cajaRegistro);
    },
    setDebito ( { commit }, debito ) {
        commit('SET_DEBITO', debito);
    },
    deleteDebito ( { commit }, debito ) {
        commit('DELETE_DEBITO', debito);
    },

    getDatos ( { commit }, tarjetaResumenPagoId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_DATOS');

            if (tarjetaResumenPagoId) {
                apiAxios.get('tarjetasresumenes/pagos/' + tarjetaResumenPagoId ) 
                    .then(res => {
                        let total = helpers.methods.formattedMoneda(res.data.total, res.data.moneda);
                        let cotizacion = helpers.methods.formattedMoneda(res.data.cotizacion);

                        let tarjetaResumenPagoDatos = [
                            // { 'nombre': 'id', 'campo': 'Nro. Orden', 'valor': res.data.id, 'formato': '' },
                            { 'nombre': 'fechaRegistro', 'campo': 'Fecha', 'valor': res.data.fechaRegistro, 'formato': 'fecha' },
                            { 'nombre': 'total', 'campo': 'Total', 'valor': total, 'formato': '' },
                        ]

                        if (res.data.cotizacion != 1) {
                            tarjetaResumenPagoDatos.push(
                                { 'nombre': 'cotizacion', 'campo': 'Cotización', 'valor': cotizacion, 'formato': '' },
                            )
                        }
                        
                        tarjetaResumenPagoDatos.push(
                            { 'nombre': 'observaciones', 'campo': 'Observaciones', 'valor': res.data.observaciones.trim(), 'formato': '' },
                        )

                        let paramsDatos = {
                            tarjetaResumenPagoDatos,
                            tarjetaResumenPagoDocumentos: res.data.documentos,
                            tarjetaResumenPagoDebitos: res.data.debitos
                        }
                                      
                        commit('SET_DATOS', paramsDatos);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            }
        })            
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}